import Storage from "../../services/storage-service/Storage";
import ErrorHandler from "../../utils/ErrorHandler";
// import AuthService from '../auth-service/AuthService'
// import AxiosService from '../axios-service/AxiosService'
// const managerBFF = process.env.REACT_APP_MANAGER_BFF_URL

export default class ActionsService {
    static findCheckedActions = async (email: string, slug: string) => {
        let token, config;

        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = { headers: { Authorization: "Bearer " + token } };
        console.log(email, slug, config);
        /*Essa questão precisa ser resolvida no backend*/
        // return await AxiosService.httpGet(managerBFF + `/v1/mini-apps/actions/users/${email}/miniapps/${slug}`, config)
        return [];
    };

    static hasAction = async (action: string, slug: string) => {
        console.log(action, slug);
        // const { email } = AuthService.getDecodedToken()
        try {
            // const res = await ActionsService.findCheckedActions(email, slug)
            // const hasActions = res?.data?.includes(action.toLowerCase()) || res?.data?.includes(action.toUpperCase())
            const hasActions = false;
            return hasActions;
        } catch (error) {
            return false;
        }
    };

    static hasAllActions = async (actions: Array<string>, slug: string) => {
        if (!actions) return false;
        if (actions.length < 1) return false;

        const resultArray = actions.map(action => {
            if (!ActionsService.hasAction(action, slug)) return false;
        });

        return !resultArray.includes(false);
    };
}
